export default __webpack_public_path__ + "static/media/Q12_4_resized.9d657ce4.jpg";